"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isString = _interopRequireDefault(require("lodash/isString"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Check id a string contains HTML tags
 * @param string {string} : 'This is some text with some <b>HTML</b>'
 * @returns {boolean}
 */

function checkHTML() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString.default)(string)) {
    return false;
  }
  return string.match(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi) !== null;
}
var _default = exports.default = checkHTML;